<template>
  <div class="index">
    <!-- 筛选 -->
    <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="100px">
        <div class="filter-col">
          <el-form-item label="甲方名称：">
            <el-input clearable v-model="filterForm.name" placeholder="请输入甲方名称"></el-input>
          </el-form-item>
          <el-form-item label="合同名称：">
            <el-input clearable v-model="filterForm.caseName" placeholder="请输入合同名称"></el-input>
          </el-form-item>
          <el-form-item label="律师名称：">
            <el-input clearable v-model="filterForm.layerName" placeholder="请输入律师名称"></el-input>
          </el-form-item>
          <!-- <el-form-item label="起始时间">
            <el-date-picker
              size="mini" type="datetime" default-time="00:00:00" v-model="filterForm.startSalaryMillisecond" :style="'width:200px;'"
              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" placeholder="选择时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="截止时间">
            <el-date-picker
              size="mini" type="datetime" default-time="00:00:00" v-model="filterForm.endSalaryMillisecond" :style="'width:200px;'"
              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" placeholder="选择时间"></el-date-picker>
          </el-form-item> -->
        </div>
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" />
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
        </div>
      </el-form>
    </section>
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <el-button type="" icon="el-icon-view" @click="viewHandler" v-if="btnShow.search" :disabled="selectRows.length!==1">查看</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="createHandler" v-if="btnShow.create">创建</el-button>
      <el-button type="primary" icon="el-icon-edit" @click="modifyHandler" v-if="btnShow.modify" :disabled="selectRows.length!==1">编辑</el-button>
      <!-- ||selectData.grantLawyerOk||selectData.grantHostOk -->
      <!-- <el-upload
        :action="importAction"
        accept=".xls,.xlsx" :limit="1" style="margin:0 10px;" :file-list="importFiles"
        :before-upload="beforeImport" :on-success="importSuccess" v-if="btnShow.import">
        <el-button type="success" icon="el-icon-upload2">数据导入</el-button>
      </el-upload> -->
      <!-- <el-button type="success" icon="el-icon-download" @click="downloadHandler">下载模板</el-button> -->
      <!-- <el-button type="success" icon="el-icon-download" @click="$refs.DownloadByArea.visible=true">下载模板</el-button> -->
      <!-- <el-button type="success" icon="el-icon-download" @click="exportHandler()" v-if="btnShow.export">数据导出</el-button> -->
      <el-button type="danger" icon="el-icon-delete" @click="deleteHandler" :disabled="selectRows.length<1" v-if="btnShow.delete">删除</el-button>
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->>
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false" :align="x.align||'center'"></el-table-column>

        <!-- <el-table-column label="文件" width="362" align="center">
          <template slot-scope="scope">

            <template v-if="Array.isArray(scope.row.fileNameAndId)">
              <p v-for="(x,i) in scope.row.fileNameAndId" :key="i" class="file-item">
                <span class="file-name">{{x.fileName}}</span>
                <a :href="'https://view.officeapps.live.com/op/view.aspx?src='+puUrl_x+'/'+x.fileId" target="_blank">
                  <el-button size="mini" plain type="success">预览</el-button>
                </a>
                <a :download="x.fileName" :href="puUrl_x+'/'+x.fileId" target="_blank" style="margin-left:10px;">
                  <el-button size="mini" plain type="primary">下载</el-button>
                </a>
              </p>
            </template>

            <template v-else-if="scope.row.fileNameAndId">
              <p class="file-item">
                <span class="file-name">{{scope.row.fileNameAndId.fileName}}</span>
                <a :href="'https://view.officeapps.live.com/op/view.aspx?src='+puUrl_x+'/'+scope.row.fileNameAndId.fileId" target="_blank">
                  <el-button size="mini" plain type="success">预览</el-button>
                </a>
                <a :download="scope.row.fileNameAndId.fileName" :href="puUrl_x+'/'+scope.row.fileNameAndId.fileId" target="_blank" style="margin-left:10px;">
                  <el-button size="mini" plain type="primary">下载</el-button>
                </a>
              </p>
            </template>

          </template>
        </el-table-column>

        <el-table-column label="支付凭证" width="121" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px" :src="scope.row.transferUrl|toimg" fit="fill"
              :preview-src-list="[scope.row.transferUrl]|toimgs" v-if="scope.row.transferUrl"></el-image>
          </template>
        </el-table-column> -->

        <el-table-column label="操作" width="300" align="center">
          <template slot-scope="scope">
            <el-button size="mini" plain type="" @click="authorizeViewHandler(scope.row)">查看授权</el-button>
            <el-button size="mini" plain type="primary" @click="authorizeEditHandler(scope.row)">修改授权</el-button>
            <!-- <el-button size="mini" plain type="success" @click="authorizeSignHandler1(scope.row)" :disabled="scope.row.grantLawyerOk">律师确定</el-button>
            <el-button size="mini" plain type="success" @click="authorizeSignHandler2(scope.row)" :disabled="scope.row.grantHostOk">甲方确定</el-button> -->
            <el-button size="mini" plain type="success" @click="applyHandler(scope.row)" v-if="scope.row.hostId===userInfo.id">发票申请</el-button>
          </template>
        </el-table-column>

      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 查看模式 -->
    <DialogView
      ref="DialogView"
      :dialogTitle="dialogTitle"
      :formItems="formItems"
      :formItems2="formItems2" />
      <!-- dialogWidth="1000px" -->

    <!-- 模态框 编辑模式 -->
    <DialogEdit
      ref="DialogEdit"
      :rules="rules"
      :dialogTitle="dialogTitle"
      :action="$api.url_upload_pu"
      :formItems="formItems"
      :formItems2="formItems2"
      @submitHandler="editSubmitHandler" />
      <!-- :isShowArea="true" -->
      
    <!-- 模态框 查看模式 -->
    <DialogView
      ref="DialogView2"
      dialogTitle="委托授权书"
      :formItems="formItems3"
      :formItems2="null"
      dialogWidth="1000px" />

    <!-- 模态框 编辑模式 -->
    <DialogEdit
      ref="DialogEdit2"
      :rules="rules"
      dialogTitle="委托授权书"
      :action="$api.url_upload_pu"
      :formItems="formItems3"
      :formItems2="null"
      dialogWidth="1000px"
      @submitHandler="editSubmitHandler2" />
      <!-- :isShowArea="true" -->

    <el-dialog
			title="导入提示"
			:close-on-click-modal="false"
			:visible.sync="isShowImportTip"
      :append-to-body="true"
			width="500px">
      <div v-html="importResult" style="text-align:left"></div>
    </el-dialog>

    <!-- <DownloadByArea ref="DownloadByArea" :xlsCode="xlsCode" /> -->
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import DialogEdit from '@/components/DialogEdit'
import DialogView from '@/components/DialogView'
// import AreaPicker from '@/components/AreaPicker_3'
import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import DownloadByArea from '@/components/DownloadByArea'
import mixin_upload from '@/Mixins/mixin_upload'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
export default {
  mixins: [mixins, mixin_upload],
  components: { AreaPicker, DialogView, DialogEdit, Pagenation, DownloadByArea },
  data() {
    return {
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      sign: 'yz_wt_weituo',
      dialogTitle: '委托合同信息',
      // fileName: 'qiyexinxi',
      // xlsCode: '50',
      // importTipKey: 'u_idCard',
      // importTiplabel: '员工身份证',
      // filterForm: {
      //   contract: {}
      // }, // 特殊

      baseInfo: [
        // { key: 'province', label: '省' },
        // { key: 'city', label: '市' },
        // { key: 'county', label: '县' },
        // { key: 'town', label: '镇' },
        // { key: 'village', label: '村' },
        { key: 'areaName', label: '地区' },

        { key: 'layerNo', label: '成竞律合字' },
        { key: 'no', label: '第X号' },
        { key: 'name', label: '甲方' },
        // { key: 'address', label: '住所' },
        // { key: 'idCard', label: '营业执照/身份证号码' },
        // { key: 'phone', label: '电话/电邮' },
        { key: 'caseName', label: '案件名称' },
        { key: 'layerName', label: '律师名称' },
        // { key: 'entrustType', label: '委托类型' },
        // { key: 'agentType', label: '代理类型' },
        // { key: 'agentPeriod', label: '代理期限类型' },
        // { key: 'otherPeriod', label: '代理期限类型其它自定义填写' },
        // { key: 'contactUserName', label: '甲方指定联系人' },
        // { key: 'oncePay', label: '一次性支付费用' },
        // { key: 'partPay', label: '分期费用' },
        // { key: 'partPercent', label: '目标额百分比费用' },
        // { key: 'dealFee', label: '案件办理经费' },
        // { key: 'otherDetail', label: '未尽事宜' },
        // { key: 'caseDate', label: '合同签定时间' },
        // { key: 'hostContract', label: '甲方负责人' },
        // { key: 'hostLeader', label: '甲方法定代表人' },
        // { key: 'agentContract', label: '乙方负责人' },
        // { key: 'agent', label: '乙方代理人' },
      ],

      rules: {
        // hostId: [{ required: true, message: '必填', trigger: 'blur' }],
        hostId: [{ required: true, message: '必填', trigger: 'change' }],
        lawyerId: [{ required: true, message: '必填', trigger: 'change' }],
        // date: [{ required: true, message: '必填', trigger: 'change' }],
        // number1: [{ required: true, trigger: 'blur', validator: this.$t.validator_number_must }],
        // number2: [{ trigger: 'blur', validator: this.$t.validator_number }],
        // date1: [{ required: true, trigger: 'blur', validator: this.$t.validator_number_8 }],
        caseDate: [{ trigger: 'blur', validator: this.$t.validator_number_8 }],
        agentEndDate: [{ trigger: 'blur', validator: this.$t.validator_number_8 }],
      },
      formItems: [
        { type: 'text', key: 'layerNo', label: '成竞律合字' },
        { type: 'text', key: 'no', label: '第X号' },
        { type: 'select_s', key: 'hostId', label: '甲方账号', options: [], remoteMethod: this.getUesrData, placeholder: '请输入电话号码' },
        { type: 'text', key: 'name', label: '甲方姓名' },
        { type: 'text', key: 'address', label: '住所' },
        { type: 'text', key: 'idCard', label: '营业执照/身份证号码' },
        { type: 'text', key: 'phone', label: '电话/电邮' },
        { type: 'text', key: 'caseName', label: '案件名称' },
        { type: 'select_s', key: 'lawyerId', label: '律师账号', options: [], remoteMethod: this.getLawyerData, placeholder: '请输入电话号码' },
        { type: 'text', key: 'layerName', label: '律师姓名' },
        { type: 'select_m', key: 'entrustType', label: '委托类型', options: ['代理人','辩护人','附带民事诉讼原告代理人','附带民事诉讼被告代理人'] },
        { type: 'select_s', key: 'agentType', label: '代理类型', options: ['一般代理','特别授权'] },
        { type: 'text', key: 'agentPeriod', label: '代理期限类型' },
        { type: 'text', key: 'otherPeriod', label: '代理期限类型其它自定义填写' },
        { type: 'text', key: 'contactUserName', label: '甲方指定联系人' },
      ],
      formItems2: [
        { type: 'text', key: 'oncePay', label: '一次性支付费用' },
        { type: 'text', key: 'partPay', label: '分期费用' },
        { type: 'text', key: 'partPercent', label: '目标额百分比费用' },
        { type: 'text', key: 'dealFee', label: '案件办理经费' },
        { type: 'textarea', key: 'otherDetail', label: '未尽事宜' },
        { type: 'text', key: 'caseDate', label: '合同签定时间', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'hostContract', label: '甲方负责人' },
        { type: 'text', key: 'hostLeader', label: '甲方法定代表人' },
        { type: 'text', key: 'agentContract', label: '乙方负责人' },
        { type: 'text', key: 'agent', label: '乙方代理人' },
      ],
      formItems3: [
        { type: 'text', key: 'layerNo', label: '成竞律书字' },
        { type: 'text', key: 'no', label: '第X号' },
        { type: 'text', key: 'hostName', label: '委托人' },
        { type: 'text', key: 'hostIdCard', label: '委托人身份证号码/注册码' },
        { type: 'text', key: 'caseName', label: '案件名称' },
        { type: 'text', key: 'agentName', label: '代理人姓名' },
        { type: 'select_s', key: 'entrustType', label: '代理人身份', options: ['委托代理人','辩护人'] },
        { type: 'text', key: 'agentType', label: '代理人权限' },
        { type: 'select_m', key: 'agentPrivilegeList', label: '代理人权限', options: [
          '调查取证',
          '提起诉讼',
          '提出答辩',
          '代为变更或者放弃诉讼请求',
          '代为承认诉讼请求',
          '提起反诉',
          '进行调解或者和解',
          '提起上诉',
          '申请执行',
          '收取或者收转执行标的',
          '签署、送达、接受法律文书',
          '其他'
        ] },
        { type: 'text', key: 'privilegeOtherDescription', label: '代理人权限其它描述' },
        { type: 'text', key: 'agentEndDate', label: '委托期限截止日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'privilegePerson', label: '授权人' },
        { type: 'text', key: 'getPrivilegePerson', label: '受托人' },
      ],

      isPartyA: false,
    }
  },
  computed: {
    importAction() {
      return this.$api.baseUrl + this.$api.url_import(this.sign)
    },
  },
  methods: {
    // 
    applyHandler(row) {
      // console.log(row)
      this.$confirm('是否申请发票？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let {
          province, city, county, town, village, lawyerId, hostId, id
        } = row
        let rData = {
          province, city, county, town, village,
          entrustId: id,
          lawyerId,
          userId: hostId,
        }

        this.$api.util_create('yz_wt_fapiao', rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('申请成功！')
            // this.searchHandler()
          } else { this._status(res.data) }
        })

      }).catch(() => {})
    },
    authorizeSignHandler1(row) {
      this.$confirm('是否确定该合同？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let rData = {
          id: row.id,
          grantLawyerOk: true,
        }

        this.$api.util_modify(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('确定成功！')
            // this.searchHandler()
            row.grantLawyerOk = true
          } else { this._status(res.data) }
        })

      }).catch(() => {})
    },
    authorizeSignHandler2(row) {
      this.$confirm('是否确定该合同？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let rData = {
          id: row.id,
          grantHostOk: true,
        }

        this.$api.util_modify(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('确定成功！')
            // this.searchHandler()
            row.grantHostOk = true
          } else { this._status(res.data) }
        })

      }).catch(() => {})
    },
    authorizeViewHandler(row) {
      console.log(row)
      this.selectRow = row
      row.grantEntrust ? '' : row.grantEntrust = {}
      this.$refs.DialogView2.viewHandler(row.grantEntrust)
    },
    authorizeEditHandler(row) {
      console.log(row)
      this.selectRow = row
      row.grantEntrust ? '' : row.grantEntrust = {}
      this.$refs.DialogEdit2.modifyHandler(row.grantEntrust)
    },
    editSubmitHandler2(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      let { province, city, county, town, village } = this.userInfo
      // let { id } = result
      let id = this.rowId
      let rData = { province, city, county, town, village, grantEntrust: {} }
      const mapList = [
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        'layerNo',
        'no',
        'hostName',
        'hostIdCard',
        'caseName',
        'agentName',
        'entrustType',
        'agentType',
        'agentPrivilegeList',
        'privilegeOtherDescription',
        'agentEndDate',
        'privilegePerson',
        'getPrivilegePerson',
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      ]
      
      mapList.forEach(x => {
        if (this.selectRow.grantEntrust[x] !== result[x]) {
          rData.grantEntrust[x] = result[x]
        }
      })
      rData.id = this.selectRow.id // 绑定修改的数据id
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      // rData.areaId = this.selectRow.areaId
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      console.log(rData)

      this.$api.util_modify(this.sign, rData).then(res => {
        if (res.data.status == 0) {
          this.$message.success('修改成功！')
          this.$refs.DialogEdit.isShowDialog = false
          this.$refs.DialogEdit.clearHandler()
          this.searchHandler()
        } else { this._status(res.data) }
      })
    },
    modifyHandlerBefore() {
      let {
        host,
        lawyer
      } = this.selectData
      this.formItems[2].options = [
        {
          label: host.u_phone,
          value: host.id,
        }
      ]
      this.formItems[8].options = [
        {
          label: lawyer.u_phone,
          value: lawyer.id,
        }
      ]
    },
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    editSubmitHandler(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      // let { id, province, city, county, town, village } = result
      let { province, city, county, town, village } = this.userInfo
      let { id } = result
      let rData = { province, city, county, town, village }
      // let rData = {}
      const mapList = [
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        'layerNo',
        'no',
        'hostId',
        'name',
        'address',
        'idCard',
        'phone',
        'caseName',
        'lawyerId',
        'layerName',
        'entrustType',
        'agentType',
        'agentPeriod',
        'otherPeriod',
        'contactUserName',
        'oncePay',
        'partPay',
        'partPercent',
        'dealFee',
        'otherDetail',
        'caseDate',
        'hostContract',
        'hostLeader',
        'agentContract',
        'agent',
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      ]

      if (this.isCreate) {
        mapList.forEach(x => {
          result[x] ? rData[x] = result[x] : ''
        })
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        // rData.areaId = this.selectData.areaId
        JSON.stringify(rData.entrustType) === '[]' ? delete rData.entrustType : ''
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        console.log(rData)
        
        this.$api.util_create(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('创建成功！')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }

      else {
        mapList.forEach(x => {
          if (this.selectData[x] !== result[x]) {
            rData[x] = result[x]
          }
        })
        rData.id = this.selectData.id // 绑定修改的数据id
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        // rData.areaId = this.selectData.areaId
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        console.log(rData)

        this.$api.util_modify(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('修改成功！')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }
    },
    getData(rD = {}) {
      console.log(rD)
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      if (this.userInfo.admin) {
      } else if (this.userInfo.privilegesList.includes('Encase-Contract-search')) {
      } else if (this.userInfo.layer) {
        rD = { pageNumber: this.pageData.currentPage }
        rD.lawyerId = this.userInfo.id
      } else {
        rD = { pageNumber: this.pageData.currentPage }
        rD.hostId = this.userInfo.id
        this.isPartyA = true
      }
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
          this.tableData = _R.map(x => {
            x.areaName = x.province + x.city + x.county + x.town + x.village
            return x
          })
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
          this.pageData.total = res.data.size
        } else { this._status(res.data) }
      })
    },
    getUesrData(val) {
      // console.log(val, this.areaIds_x)
      let rD = {
        // areaId: this.areaIds_x[this.areaIds_x.length - 1],
        u_phone: val,
        personal: true,
      }
      // console.log(rD)
      this.$api.getUserList(rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(_R)
          this.formItems[2].options = _R.map(x => {
            return {
              label: x.u_phone,
              value: x.id,
            }
          })
        } else { this._status(res.data) }
      })
    },
    getLawyerData(val) {
      // console.log(val, this.areaIds_x)
      let rD = {
        // areaId: this.areaIds_x[this.areaIds_x.length - 1],
        u_phone: val,
        layer: true,
      }
      // console.log(rD)
      this.$api.getUserList(rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          this.formItems[8].options = _R.map(x => {
            return {
              label: x.u_phone,
              value: x.id,
            }
          })
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    const powerList = this.userInfo.privilegesList
    const powerStr = powerMap[this.sign]
    // console.log(powerStr)
    this.btnShow.search = true
    // const mapList = ['search','create','modify','delete','import','export']
    const mapList = ['create','modify','delete','import','export']
    if (this.userInfo.admin) {
      mapList.forEach(x => {
        this.btnShow[x] = true
      })
    } else {
      mapList.forEach(x => {
        if (x && powerList.includes(powerStr + '-' + x)) {
          this.btnShow[x] = true
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}





.file-item{height: 40px;line-height: 40px;display: flex;}
.file-name{
  display: inline-block;min-width: 120px;max-width: 200px;padding: 0 10px;
  overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
}
</style>